import React from "react";
import { Box } from "@mui/material";

/**
 * The type pill on its own row at the bottom of a card's header band
 * ("Composed logo", "Gradient", ...): now that one list holds every type of
 * selection or reproduction, the card itself says which type it is.
 */
export default function KindChip({ Icon, label, title }) {
    return (
        <Box
            component="span"
            title={title || label}
            aria-label={title || label}
            sx={{
                display: "inline-flex", alignItems: "center", gap: 0.5,
                px: 0.9, py: 0.2, borderRadius: 999, flexShrink: 0,
                bgcolor: "rgba(255,255,255,0.14)", color: "rgba(255,255,255,0.92)",
                border: "1px solid rgba(255,255,255,0.18)",
                fontSize: "0.72rem", fontWeight: 600, letterSpacing: 0.1,
                lineHeight: 1.6, whiteSpace: "nowrap",
            }}
        >
            {Icon ? <Icon sx={{ fontSize: 12 }} /> : null}
            {label}
        </Box>
    );
}
